
export const secAccountLocation = "/settings/securityaccounts";
